import React, { FC, Fragment, HTMLProps, useMemo } from "react";
import stl from "./index.module.scss";
import { Quantity } from "../../components";
import { isPresent } from "../../utils";
import cn from "classnames";
import { PersonType } from "../../store/models";

type Value = (PersonType & { quantity: number })[];
interface Props
  extends Omit<HTMLProps<HTMLDivElement>, "value" | "max" | "onChange"> {
  value?: Value;
  onChange?: (v: { id: number; qty: number; name: string }) => void;
  maxValue?: Value;
  min?: number;
  disabled?: boolean;
  fullwidth?: boolean;
}
const PersonTypes: FC<Props> = ({
  value,
  onChange,
  className,
  disabled,
  maxValue,
  min,
  fullwidth,
  ...props
}) => {
  const totalGuests = useMemo<number>(() => {
    return value?.reduce((acc, { quantity }) => acc + quantity, 0) ?? 0;
  }, [value]);

  return (
    <div
      className={cn(className, stl.block, { [stl.fullwidth]: fullwidth })}
      {...props}
    >
      {value?.map(({ id, name, quantity, description }) => {
        const maxPersonTypeData: Value[0] | undefined = maxValue
          ? maxValue.find((item) => item.id === id)
          : undefined;

        return (
          <Fragment key={name}>
            <div>
              <h4 className={stl.name}>{name}</h4>
              {description && <i className={stl.description}>{description}</i>}
            </div>
            <div>
              <Quantity
                disabled={disabled}
                maxDisabled={
                  isPresent(maxPersonTypeData) &&
                  quantity >= maxPersonTypeData.quantity
                }
                minDisabled={isPresent(min) && totalGuests <= min}
                value={quantity}
                onChange={(qty) => onChange?.({ id, qty, name })}
                min={0}
              />
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default PersonTypes;
